module.exports = __webpack_public_path__ + "img/yingjie.b78b41ec.png";